export enum ExposedHeaders {
  AccountToken = 'x-edgvr-account-token',
}
